(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncHeight(bar) {
      document.documentElement.style.setProperty('--announcement-bar-height', bar.offsetHeight + 'px');
    }

    function initBar(bar) {
      if (bar.dataset.announcementInit) return;
      bar.dataset.announcementInit = 'true';

      syncHeight(bar);
      window.addEventListener('resize', function () { syncHeight(bar); });

      var mode = bar.dataset.announcementMode;
      if (mode === 'marquee') return;

      var track = bar.querySelector('[data-announcement-track]');
      var items = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-item]'));
      var prev = bar.querySelector('[data-announcement-prev]');
      var next = bar.querySelector('[data-announcement-next]');
      var speed = parseFloat(getComputedStyle(bar).getPropertyValue('--rotation-speed')) * 1000;
      var autorotate = bar.hasAttribute('data-announcement-autorotate') && items.length > 1;
      var index = 0;
      var timer = null;

      if (items.length < 2) return;

      function show(nextIndex) {
        index = (nextIndex + items.length) % items.length;

        items.forEach(function (item, i) {
          var active = i === index;
          item.classList.toggle('is-active', active);
          if (active) {
            item.removeAttribute('aria-hidden');
          } else {
            item.setAttribute('aria-hidden', 'true');
          }
        });

        if (mode === 'slide' && track) {
          track.style.transform = 'translateX(-' + index * 100 + '%)';
        }
      }

      function start() {
        if (!autorotate || timer || document.hidden) return;
        timer = setInterval(function () { show(index + 1); }, speed || 5000);
      }

      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      function restart() {
        stop();
        start();
      }

      if (prev) prev.addEventListener('click', function () { show(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { show(index + 1); restart(); });

      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', start);
      bar.addEventListener('focusin', stop);
      bar.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      start();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-announcement-bar]').forEach(initBar);
    }

    initAll();

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.querySelector('[data-announcement-bar]')) {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    if (customElements.get('cart-drawer')) return;

    var SECTIONS = 'cart-drawer,cart-icon-bubble';

    class CartDrawer extends HTMLElement {
      constructor() {
        super();
        this._lastTrigger = null;
        this._onKey = this._onKey.bind(this);
        this._onDocClick = this._onDocClick.bind(this);
        this._onPanelClick = this._onPanelClick.bind(this);
        this._onSubmit = this._onSubmit.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this._onPanelClick);
        document.addEventListener('keydown', this._onKey);
        document.addEventListener('click', this._onDocClick);
        document.addEventListener('submit', this._onSubmit, true);
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this._onKey);
        document.removeEventListener('click', this._onDocClick);
        document.removeEventListener('submit', this._onSubmit, true);
      }

      open(trigger) {
        this._lastTrigger = trigger || document.activeElement;
        this.classList.add('is-open');
        this.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-drawer-open');
        var closeBtn = this.querySelector('[data-cart-close].cart-drawer__close') || this.querySelector('.cart-drawer__panel');
        if (closeBtn && closeBtn.focus) {
          requestAnimationFrame(function () { closeBtn.focus(); });
        }
      }

      close() {
        this.classList.remove('is-open');
        this.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cart-drawer-open');
        if (this._lastTrigger && this._lastTrigger.focus) {
          this._lastTrigger.focus();
        }
      }

      toggle(trigger) {
        if (this.classList.contains('is-open')) this.close();
        else this.open(trigger);
      }

      announce(msg) {
        var live = this.querySelector('[data-cart-live]');
        if (live) live.textContent = msg;
      }

      refresh(sections) {
        if (sections && sections['cart-drawer']) {
          var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = doc.querySelector('cart-drawer');
          if (fresh) this.innerHTML = fresh.innerHTML;
          this.dataset.empty = fresh && fresh.dataset.empty ? fresh.dataset.empty : 'true';
        }
        if (sections && sections['cart-icon-bubble']) {
          document.querySelectorAll('[data-cart-bubble-host]').forEach(function (host) {
            var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var bubble = doc.querySelector('.cart-bubble') || doc.body.firstElementChild;
            if (bubble) host.innerHTML = bubble.outerHTML;
          });
        }
        if (this.classList.contains('is-open')) {
          var closeBtn = this.querySelector('[data-cart-close].cart-drawer__close') || this.querySelector('.cart-drawer__panel');
          if (closeBtn && closeBtn.focus) {
            requestAnimationFrame(function () { closeBtn.focus(); });
          }
        }
      }

      _onKey(e) {
        if (e.key === 'Escape' && this.classList.contains('is-open')) {
          e.preventDefault();
          this.close();
        }
      }

      _onDocClick(e) {
        var trigger = e.target.closest('[data-cart-toggle]');
        if (trigger) {
          e.preventDefault();
          this.open(trigger);
        }
      }

      _onPanelClick(e) {
        var close = e.target.closest('[data-cart-close]');
        if (close && this.contains(close)) {
          var isLink = close.tagName === 'A' && close.getAttribute('href');
          if (!isLink) e.preventDefault();
          this.close();
          return;
        }
        var inc = e.target.closest('[data-cart-increase]');
        var dec = e.target.closest('[data-cart-decrease]');
        var rem = e.target.closest('[data-cart-remove]');
        if (inc) {
          e.preventDefault();
          this._delta(inc.dataset.key, 1);
        } else if (dec) {
          e.preventDefault();
          this._delta(dec.dataset.key, -1);
        } else if (rem) {
          e.preventDefault();
          this._setQty(rem.dataset.key, 0);
        }
      }

      _onSubmit(e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        var action = form.getAttribute('action') || '';
        if (!/\/cart\/add/.test(action)) return;
        e.preventDefault();
        var data = new FormData(form);
        data.append('sections', SECTIONS);
        data.append('sections_url', window.location.pathname);
        var self = this;
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.classList.add('is-loading');
        this.classList.add('is-loading');
        this.open(submitBtn);
        fetch('/cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (response) {
            if (response && response.status && response.status >= 400) {
              throw new Error(response.description || 'cart add failed');
            }
            self.refresh(response.sections);
            self.classList.remove('is-loading');
            if (submitBtn) submitBtn.classList.remove('is-loading');
            self.announce('Carrito actualizado');
          })
          .catch(function () {
            self.classList.remove('is-loading');
            if (submitBtn) submitBtn.classList.remove('is-loading');
            self.close();
          });
      }

      _delta(key, change) {
        var item = this.querySelector('[data-cart-item][data-key="' + CSS.escape(key) + '"]');
        if (!item) return;
        var qtyEl = item.querySelector('[data-cart-qty]');
        var current = qtyEl ? parseInt(qtyEl.textContent, 10) || 0 : 0;
        var next = Math.max(0, current + change);
        this._setQty(key, next);
      }

      _setQty(key, quantity) {
        var self = this;
        this.classList.add('is-loading');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: SECTIONS,
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            self.refresh(data.sections);
            self.classList.remove('is-loading');
            self.announce('Carrito actualizado');
          })
          .catch(function () {
            self.classList.remove('is-loading');
          });
      }
    }

    customElements.define('cart-drawer', CartDrawer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(carousel) {
      if (carousel.dataset.carouselInit) return;
      carousel.dataset.carouselInit = 'true';

      var track = carousel.querySelector('[data-carousel-track]');
      var prev = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      var nav = carousel.querySelector('.collection-carousel__nav');
      if (!track || !prev || !next) return;

      function update() {
        var media = carousel.querySelector('.collection-carousel__media');
        if (media) {
          carousel.style.setProperty('--media-half', media.offsetHeight / 2 + 'px');
        }

        var maxScroll = track.scrollWidth - track.clientWidth;
        if (nav) nav.classList.toggle('is-visible', maxScroll > 1);
        prev.disabled = track.scrollLeft <= 0;
        next.disabled = track.scrollLeft >= maxScroll - 1;
      }

      function page(direction) {
        track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-collection-carousel]').forEach(initCarousel);
    }

    initAll();
    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var hamburger = document.querySelector('.site-header__hamburger');
    var drawer = document.getElementById('mobile-nav');
    var overlay = document.querySelector('.site-header__drawer-overlay');
    var closeBtn = document.querySelector('.site-header__drawer-close');

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    hamburger.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    var header = document.querySelector('.site-header');
    if (!header) return;

    // The hero and `scroll-padding-top` size themselves against
    // --site-header-height, so the token tracks the bar's real height rather
    // than the breakpoint guess it starts from.
    function syncHeaderHeight() {
      document.documentElement.style.setProperty('--site-header-height', header.offsetHeight + 'px');
    }

    syncHeaderHeight();
    window.addEventListener('resize', syncHeaderHeight);
    if (window.ResizeObserver) {
      new ResizeObserver(syncHeaderHeight).observe(header);
    }

    var lastScrollY = window.scrollY;
    var scrollThreshold = 60;
    var ticking = false;

    function updateHeader() {
      ticking = false;
      var currentScrollY = window.scrollY;
      var hidden = currentScrollY > scrollThreshold && currentScrollY > lastScrollY;
      header.classList.toggle('is-hidden', hidden);
      lastScrollY = currentScrollY;
    }

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateHeader);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(hero) {
      if (hero.dataset.heroInit) return;
      hero.dataset.heroInit = 'true';

      var track = hero.querySelector('[data-hero-track]');
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
      var prev = hero.querySelector('[data-hero-prev]');
      var next = hero.querySelector('[data-hero-next]');
      var speed = parseFloat(getComputedStyle(hero).getPropertyValue('--rotation-speed')) * 1000;
      var autorotate = hero.hasAttribute('data-hero-autorotate');
      var index = 0;
      var timer = null;

      if (!track || slides.length < 2) return;

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';

        slides.forEach(function (slide, i) {
          if (i === index) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      function start() {
        if (!autorotate || timer || document.hidden) return;
        timer = setInterval(function () { show(index + 1); }, speed || 6000);
      }

      function stop() {
        if (!timer) return;
        clearInterval(timer);
        timer = null;
      }

      function goTo(nextIndex) {
        show(nextIndex);
        stop();
        start();
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      hero.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowLeft') goTo(index - 1);
        if (event.key === 'ArrowRight') goTo(index + 1);
      });

      var touchStartX = 0;
      var touchDeltaX = 0;

      hero.addEventListener('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
        stop();
      }, { passive: true });

      hero.addEventListener('touchmove', function (event) {
        touchDeltaX = event.touches[0].clientX - touchStartX;
      }, { passive: true });

      hero.addEventListener('touchend', function () {
        if (Math.abs(touchDeltaX) > 40) {
          if (touchDeltaX < 0) {
            show(index + 1);
          } else {
            show(index - 1);
          }
        }
        start();
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      start();
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-hero-carousel]').forEach(initHero);
    }

    initAll();

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var hero = e.target.closest('[data-hero-carousel]');
      if (!hero) return;
      var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
      var track = hero.querySelector('[data-hero-track]');
      var position = slides.indexOf(e.target);
      if (track && position > -1) {
        track.style.transform = 'translateX(-' + position * 100 + '%)';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
